const ACRONYMS = new Set(['it', 'hr', 'ip', 'ai', 'kpi', 'esg', 'nda', 'sop', 'erp', 'crm', 'gdpr', 'id']);

export function formatDocType(type) {
  if (!type) return '';
  return type.split(/[-_\s]+/).map(word =>
    ACRONYMS.has(word.toLowerCase()) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
}
